import {Injectable} from '@angular/core';
import {BehaviorSubject} from 'rxjs';
import {HttpContext, HttpContextToken} from '@angular/common/http';

/**
 * true の通信は全画面のローディング表示 (spinner) を出さない。
 * オートコンプリートの候補検索など、入力中に頻繁に飛ぶ通信で画面がちらつくのを防ぐ。
 */
export const SKIP_LOADING = new HttpContextToken<boolean>(() => false);

/** SKIP_LOADING を立てた HttpContext */
export function skipLoadingContext(): HttpContext {
    return new HttpContext().set(SKIP_LOADING, true);
}

@Injectable()
export class LoadingService{
    public isLoading = new BehaviorSubject(false);
    constructor() { }
}